import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index.vue'
import Success from '@/pages/success.vue'
import Fail from '@/pages/fail.vue'

Vue.use(Router)

export default new Router({
  mode: 'history', // 去掉url中的#
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/success',
      name: 'Success',
      component: Success
    },{
      path: '/fail',
      name: 'fail',
      component: Fail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js